import { CurrencyCell } from '@breeze-ai/ui-library';

import { useUserSetting } from '../../../context/auth/auth-hooks';
import { type SupportedCurrencies } from '../../../model/CurrencyValue';
import { useQuoteCosts } from '../../hooks/useQuoteCosts';
import { type QuotePriceProperties } from '../../types/quote';
import { QuotePriceBreakdownTooltip } from '../QuotePriceBreakdownTooltip/QuotePriceBreakdownTooltip';

interface QuoteCostTableCellProps extends QuotePriceProperties {
  premium_value: number;
  premium_currency: SupportedCurrencies;
}

export function QuoteCostTableCell(props: QuoteCostTableCellProps) {
  const showPremiumsInDefaultCurrency = useUserSetting<boolean>(
    'show_premiums_in_default_currency',
  );

  const { taxCost, totalCost, premiumCurrency } = useQuoteCosts(props);

  const { exchange_rate } = props;
  const shouldShowTooltip = Boolean(
    taxCost || (exchange_rate && !showPremiumsInDefaultCurrency),
  );

  return (
    <CurrencyCell
      value={totalCost}
      currency={premiumCurrency}
      suffix={
        shouldShowTooltip && (
          <QuotePriceBreakdownTooltip className="w-3.5 h-3.5" {...props} />
        )
      }
    />
  );
}
